import React, { Component } from "react";
import InputRange from "react-input-range";
import Picker from "../Common/Picker";

import Api from "../../lib/componentApi";
import mixpanel from "../../lib/mixPanel";

import getRegularPlaceData from "../../lib/getRegularPlaceData";
import getLocalData from "../../lib/getLocalData";
import getHeaderData from "../../lib/getHeaderData";
import setLocalDeliveryData from "../../lib/setLocalDeliveryData";
import getAppErrors from "../../lib/appErrors";
import { getDeliveryDateData } from "../../lib/getDeliveryDateData";

import LocationSearchInput from "../Common/Places";
import AppErrors from "../Common/AppErrors";

const addressIconsWithId = {
  1: "house",
  2: "sun",
  3: "bag",
  4: "love",
  5: "locate",
  6: "pizza",
  7: "pineapple",
  8: "doughnut",
  9: "lollipop",
  10: "soda-2",
  11: "pia-colada",
  12: "parasol",
  13: "smallprize",
  14: "juice",
  15: "watermelon"
};
export default class DeliveryDetails extends Component {
  constructor(props) {
    super(props);
    const staticContext = props.staticContext;
    let localData, userAddressId, delivery, preOrder, uid;
    let addresses = [];
    localData = getLocalData("deliveryDetails");
    const { initialData } = getHeaderData(staticContext, "user");
    if (localData) {
      if (localData.userAddressId) {
        userAddressId = localData.userAddressId;
      }
      if (localData.delivery) {
        delivery = localData.delivery;
      }
      if (localData.preOrder) {
        preOrder = localData.preOrder;
      }
    }
    if (initialData && initialData.addresses) {
      addresses = initialData.addresses;
      uid = initialData.uid;
    }

    this.state = {
      lat: null,
      lon: null,
      isPostalCode: false,
      currentAddress: "",
      when: (preOrder && "preOrder") || "asap",
      how: (delivery && "delivery") || "collection",
      collectionDistance: props.defaultDistance || 1,
      preOrderClassName: "",
      dateData: [],
      preOrder: preOrder || "",
      searchInputPlaceholder: "",
      selectCurrent: false,
      addressUid: userAddressId || null,
      routeName: "",
      postalCode: "",
      addressLine2: "",
      flatNumber: "",
      addresses,
      uid,
      preOrderPopup: false,
      errorMessage: null
    };
  }
  componentDidMount() {
    mixpanel.track("Delivery Details Screen");
    const { preOrderEnd, preOrderStart } = this.props;
    let dateData = getDeliveryDateData(preOrderStart, preOrderEnd, false);
    this.setState({
      dateData
    });
    this.getLocation();
  }
  handleChangeHow = how => {
    this.setState({ how }, () => {
      const { collectionDistance } = this.state;
      const _how = (how === "collection" && "Collection") || "Delivery";
      mixpanel.track("How Options Change", {
        _how,
        _distance: collectionDistance
      });
    });
  };
  handleChangeWhen = when => {
    this.setState({ when });
    if (when === "asap") {
      mixpanel.track("When Options Change", { _preOrder: false });
      this.setState({ preOrder: "", preOrderPopup: false });
    } else if (when === "preOrder") {
      var html = document.getElementById("static");
      html.classList.add("html-overflow");
      this.setState({
        preOrderPopup: true
      });
    }
  };
  handleChangeDistance = value => {
    mixpanel.track("Collection Distance Change");
    this.setState({ collectionDistance: value });
  };
  getAddressIconPath = addressIconId => {
    let currentId = parseInt(addressIconId) || 1;
    console.log(addressIconId, currentId, addressIconId[currentId]);
    return `/svg/address-svg/${addressIconsWithId[currentId]}.svg`;
  };
  getLocation = () => {
    var self = this;
    var options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };

    function success(pos) {
      var crd = pos.coords;
      mixpanel.track("Track Your Orders System", { Allow: true });
      self.setState({ lat: crd.latitude, lon: crd.longitude });
      //eslint-disable-next-line
      var geocoder = new google.maps.Geocoder();
      //eslint-disable-next-line
      var location = new google.maps.LatLng(
        pos.coords.latitude,
        pos.coords.longitude
      );
      geocoder.geocode({ latLng: location }, async function(results, status) {
        //eslint-disable-next-line
        if (status == google.maps.GeocoderStatus.OK) {
          const addresses = results[0].address_components;
          const {
            postalCode,
            routeName,
            addressLine2,
            flatNumber
          } = await getRegularPlaceData(addresses);
          self.setState({
            currentAddress: routeName,
            postalCode,
            addressLine2,
            flatNumber
          });
        }
      });
    }
    function error(err) {
      mixpanel.track("Track Your Orders System", { Allow: false });
      console.warn(`ERROR(${err.code}): ${err.message}`);
    }
    if (navigator && navigator.geolocation) {
      mixpanel.track("Location Permission Screen");
      navigator.geolocation.getCurrentPosition(success, error, options);
    }
  };
  onSelectPreOrder = (name, value) => {
    var html = document.getElementById("static");
    html.classList.remove("html-overflow");
    this.setState({
      preOrder: value
    });
  };
  onCancelPreOrder = () => {
    var html = document.getElementById("static");
    html.classList.remove("html-overflow");
    this.setState({
      when: "asap",
      preOrder: "",
      preOrderPopup: false
    });
  };
  handleSelectPreOrder = () => {
    const { preOrder } = this.state;
    if (preOrder) {
      var html = document.getElementById("static");
      html.classList.remove("html-overflow");
      this.setState(
        {
          preOrderPopup: false,
          when: "preOrder"
        },
        () => {
          mixpanel.track("When Options Change", {
            _preOrder: true,
            _time: preOrder
          });
        }
      );
    }
  };
  handleSelectAddress = (addressUid, addressText, postalCode) => {
    if (addressUid === "currentLocation") {
      mixpanel.track("Address Options Change", {
        _address: "Current Location"
      });
      const { currentAddress } = this.state;
      this.setState({
        selectCurrent: true,
        addressUid: "",
        selectPlace: false,
        searchInputPlaceholder: currentAddress
      });
    } else {
      mixpanel.track("Address Options Change", {
        _address: postalCode
      });
      this.setState({
        selectCurrent: false,
        selectPlace: false,
        addressUid: addressUid,
        searchInputPlaceholder: addressText,
        postalCode
      });
    }
  };
  getButtonValidate = () => {
    const {
      lat,
      lon,
      addressUid,
      when,
      how,
      collectionDistance,
      preOrder,
      selectCurrent,
      selectPlace
    } = this.state;
    let disabled = true,
      confirmAddress = false,
      confirmHow = false,
      confirmWhen = false;
    if (
      (selectCurrent && lat && lon) ||
      (selectPlace && lat && lon) ||
      addressUid
    ) {
      confirmAddress = true;
    }
    if ((when === "preOrder" && preOrder !== "") || when === "asap") {
      confirmWhen = true;
    }
    if (how === "delivery" || (how === "collection" && collectionDistance)) {
      confirmHow = true;
    }
    if (confirmAddress && confirmHow && confirmWhen) {
      disabled = false;
    }
    return disabled;
  };

  handleSubmitPlace = async place => {
    const lat = place.lat,
      lon = place.lng,
      addresses = place.address,
      isPostalCode = place.isPostalCode;
    const {
      postalCode,
      routeName,
      addressLine2,
      flatNumber
    } = await getRegularPlaceData(addresses);
    this.setState({
      lat,
      lon,
      addressUid: null,
      selectPlace: true,
      addressLine2,
      isPostalCode,
      flatNumber,
      searchInputPlaceholder: routeName,
      selectCurrent: false,
      postalCode: postalCode
    });
    //burayı gözden geçir
    mixpanel.track("Select Delivery Location Address Line Click");
  };
  setLocalDataCallback = (deliveryData, route) => {
    const { postalCode, delivery, distance, slugName, preOrder } = deliveryData;
    mixpanel.track("Change Delivery Details", {
      _postCode: postalCode,
      _when: preOrder || "Asap",
      _how: (delivery && "Delivery") || "Collection",
      _distance: distance
    });

    if (route === "detail") {
      window.location.href = `/restaurant/${deliveryData.city}/${
        deliveryData.adminWard
      }/${slugName}/?postcode=${deliveryData.postalCode}&time=${preOrder ||
        "now"}`;
    }
    if (route === "list") {
      let href;
      if (deliveryData.adminWard) {
        href = `/restaurants/${deliveryData.city}/${
          deliveryData.adminWard
        }/?postcode=${deliveryData.postalCode}&time=${preOrder || "now"}`;
      } else {
        href = `/restaurants/${deliveryData.city}/list/?postcode=${
          deliveryData.postalCode
        }&time=${preOrder || "now"}`;
      }
      if (href) {
        window.location.href = href;
      }
    }
  };
  submitDeliveryDetails = uid => {
    const { slugName, route } = this.props;
    localStorage.removeItem("deliveryDetails");
    const {
      lat,
      lon,
      addressUid,
      when,
      how,
      collectionDistance,
      preOrder,
      searchInputPlaceholder,
      postalCode,
      addressLine2,
      flatNumber,
      isPostalCode
    } = this.state;
    Api.post(
      "/api/route/data",
      { postalCode },
      (postalResponse, postalErros) => {
        if (postalErros) {
          if (postalErros === 503) {
            this.setState(() => {
              throw postalErros;
            });
          } else {
            console.log(postalErros);
          }
        } else if (postalResponse.code) {
          const error = getAppErrors(postalCode.code);
          this.setState({
            errorMessage: (error && error.message) || postalResponse.message
          });
        } else {
          if (!postalResponse.error) {
            let deliveryData = {
              delivery: how === "delivery",
              distance:
                (how === "collection" && parseFloat(collectionDistance)) || 0,
              userAddressId: addressUid,
              lat,
              lon,
              preOrder: (when === "asap" && "") || preOrder,
              asap: when === "asap",
              routeName: searchInputPlaceholder,
              postalCode,
              uid,
              addressLine2,
              flatNumber,
              isPostalCode,
              slugName,
              adminWard:
                (postalResponse.adminWard &&
                  postalResponse.adminWard.slugAdminWard) ||
                "",
              adminWardName:
                (postalResponse.adminWard &&
                  postalResponse.adminWard.adminWard) ||
                "",
              city: postalResponse.city.slugName
            };
            const jsonData = JSON.stringify(deliveryData);

            setLocalDeliveryData(jsonData, () =>
              this.setLocalDataCallback(deliveryData, route)
            );
          }
        }
      }
    );
  };
  render() {
    const {
      currentAddress,
      dateData,
      searchInputPlaceholder,
      when,
      how,
      collectionDistance,
      selectCurrent,
      addressUid,
      addresses,
      uid,
      preOrderPopup,
      preOrder,
      errorMessage
    } = this.state;

    const { onCloseSection, maxDistance } = this.props;
    const locationInputPlaceholder =
      searchInputPlaceholder || "e.g. 39 Old Town";
    const buttonDisabled = this.getButtonValidate();
    const locationInputClassName = "";
    const dateOption = {
      date: dateData
    };
    const valueOption = {
      date: preOrder || dateData[0]
    };
    return (
      (errorMessage && (
        <AppErrors
          message={errorMessage}
          onClickClose={() => this.setState({ errorMessage: null })}
        />
      )) || (
        <div>
          <div className="modal-bg" />
          <div className="modal">
            {/* Header */}
            <div className="head-general with-back">
              <a
                href="javascript: void(0)"
                className="back"
                onClick={() => onCloseSection("changeDelivery")}
              >
                <img src="/png/chevron-left.png" />
              </a>
              <h4>Delivery Details</h4>
              <a
                href="javascript: void(0)"
                className="close"
                onClick={() => onCloseSection("changeDelivery")}
              >
                <i className="icon icon-close" />
              </a>
            </div>
            {/* Header */}
            <div className="modal-body">
              <div className="row center-sm">
                <div className="col-sm-8">
                  <div className="delivery-details">
                    <div className="input-group">
                      <icon className="icon icon-location-3" />
                      <LocationSearchInput
                        placeholder={locationInputPlaceholder}
                        className={locationInputClassName}
                        onSubmit={this.handleSubmitPlace}
                      />
                    </div>

                    <div>
                      <ul className="address-list">
                        {currentAddress && (
                          <li className="active current">
                            <a
                              href="javascript: void(0)"
                              className="d-flex justify-content-between align-items-center"
                              onClick={() =>
                                this.handleSelectAddress("currentLocation")
                              }
                            >
                              <div className="d-flex align-items-center">
                                <icon className="icon icon-current-location" />
                                <h4>Current Location</h4>
                              </div>
                              <div className="d-flex align-items-center">
                                <p>{currentAddress}</p>
                                <div className="visible-xs">
                                  {(selectCurrent && (
                                    <icon
                                      className="icon icon-ok-blue"
                                      style={{ marginLeft: "10px" }}
                                    />
                                  )) || <noscript />}
                                </div>
                              </div>
                            </a>
                            <div className="hide-xs">
                              {(selectCurrent && (
                                <icon className="icon icon-ok-blue" />
                              )) || <noscript />}
                            </div>
                          </li>
                        )}
                        {(addresses &&
                          addresses.length &&
                          addresses.map(address => (
                            <li
                              className={
                                (addressUid === address.id && "active") || ""
                              }
                              key={address.id}
                              onClick={() =>
                                this.handleSelectAddress(
                                  address.id,
                                  address.addressLine1,
                                  address.postalCode,
                                  address.addressLine2,
                                  address.flatNumber
                                )
                              }
                            >
                              <a
                                href="javascript: void(0)"
                                className="d-flex justify-content-between align-items-center"
                              >
                                <div>
                                  <a className="p0" style={{ marginRight: 10 }}>
                                    <img
                                      src={this.getAddressIconPath(
                                        address.addressIconId
                                      )}
                                    />
                                  </a>
                                </div>
                                <div className="flex-grow-1">
                                  {(address.title && (
                                    <h4>{address.title}</h4>
                                  )) || <noscript />}
                                  <p>
                                    {address.addressLine1} {address.postalCode}
                                  </p>
                                </div>
                                {(addressUid === address.id && (
                                  <icon className="icon icon-ok-blue" />
                                )) || <noscript />}
                              </a>
                            </li>
                          ))) || <noscript />}
                      </ul>
                    </div>

                    <div className="white-bg delivery-box mt-10px">
                      <h4>When</h4>
                      <ul>
                        <li
                          className={(when === "asap" && "active") || ""}
                          onClick={() => this.handleChangeWhen("asap")}
                        >
                          <a href="javascript: void(0)">ASAP</a>
                          {(when === "asap" && (
                            <icon className="icon icon-ok-blue" />
                          )) || <noscript />}
                        </li>
                        <li
                          className={(when === "preOrder" && "active") || ""}
                          onClick={() => this.handleChangeWhen("preOrder")}
                        >
                          <a href="javascript: void(0)">
                            Pre-Order
                            {preOrder && (
                              <p
                                className="small-label"
                                style={{ paddingTop: "2px" }}
                              >
                                {preOrder}
                              </p>
                            )}
                          </a>
                          {(when === "preOrder" && (
                            <icon className="icon icon-ok-blue" />
                          )) || <noscript />}
                        </li>
                      </ul>
                    </div>

                    {(preOrderPopup && (
                      <Picker
                        optionGroups={dateOption}
                        title="Pre-order"
                        valueGroups={valueOption}
                        onChange={this.onSelectPreOrder}
                        onCancel={this.onCancelPreOrder}
                        onSubmit={this.handleSelectPreOrder}
                      />
                    )) || <noscript />}

                    <div className="white-bg delivery-box mt-10px">
                      <h4>How</h4>
                      <ul>
                        <li
                          className={(how === "delivery" && "active") || ""}
                          onClick={() => this.handleChangeHow("delivery")}
                        >
                          <a href="javascript: void(0)">Delivery</a>
                          {(how === "delivery" && (
                            <icon className="icon icon-ok-blue" />
                          )) || <noscript />}
                        </li>
                        <li
                          className={(how === "collection" && "active") || ""}
                          onClick={() => this.handleChangeHow("collection")}
                        >
                          <a href="javascript: void(0)">
                            Collection{" "}
                            <span className="small-label">
                              (Even more rewarding!)
                            </span>
                          </a>
                          {(how === "collection" && (
                            <icon className="icon icon-ok-blue" />
                          )) || <noscript />}
                        </li>
                      </ul>
                    </div>
                    {(how === "collection" && (
                      <div className="white-bg delivery-box mt-10px">
                        <h4>Distance</h4>
                        <div className="input-range-div">
                          <InputRange
                            step={0.1}
                            maxValue={maxDistance || 2}
                            minValue={0}
                            formatLabel={value =>
                              `${parseFloat(value).toFixed(2)} mil`
                            }
                            value={collectionDistance}
                            onChange={value => this.handleChangeDistance(value)}
                          />
                        </div>
                      </div>
                    )) || <noscript />}

                    <div className="use-buttons" style={{ marginBottom: 50 }}>
                      <button
                        disabled={buttonDisabled}
                        onClick={() => this.submitDeliveryDetails(uid || "")}
                        className={
                          (buttonDisabled && "btn btn-gray") || "btn btn-blue"
                        }
                      >
                        {(how === "collection" && "Done") || "OK"}
                      </button>
                    </div>
                  </div>
                  {/* .modal-body */}
                </div>{" "}
                {/* .delivery-detail */}
              </div>{" "}
              {/* .col-sm-8 */}
            </div>{" "}
            {/* .row */}
          </div>{" "}
          {/* .modal */}
        </div>
      )
    );
  }
}
